import { render, staticRenderFns } from "./huiyi-register.vue?vue&type=template&id=524f8001"
import script from "./huiyi-register.vue?vue&type=script&lang=js"
export * from "./huiyi-register.vue?vue&type=script&lang=js"
import style0 from "./huiyi-register.vue?vue&type=style&index=0&id=524f8001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports